import { statusLevel } from './const';
import { transContactModel2ContactItem } from './common';
export const getValidModel = (_pre, _cur) => {
    const compareArr = ['type', 'visibleCode', 'accountStatus', 'id'];
    const compareMap = {
        type: {
            enterprise: 3,
            personal: 2,
            external: 1,
        },
        visibleCode: {
            0: 1,
            1: 0,
            2: 0,
            3: 0,
            4: 0,
            5: 0,
            6: 0,
            7: 0,
            8: 0,
        },
        accountStatus: {
            5: 1,
            6: 2,
            4: 3,
            1: 4,
            2: 5,
            3: 6,
            undefined: 0,
        },
    };
    let result;
    const pre = _pre.contact;
    const cur = _cur.contact;
    compareArr.forEach(prop => {
        if (!result && pre[prop] !== cur[prop]) {
            let value = pre[prop];
            let value2 = cur[prop];
            const obj = compareMap[prop];
            if (obj) {
                value = obj[value + ''];
                value2 = obj[value2 + ''];
            }
            if (value && value2) {
                result = value.toString().localeCompare(value2.toString(), 'zh') >= 0 ? _pre : _cur;
            }
        }
    });
    return result || _pre;
};
export const getValidContact = (pre, cur) => {
    if (!pre) {
        return cur;
    }
    if (!cur) {
        return cur;
    }
    if (pre.visibleCode === 0) {
        return pre;
    }
    if (cur.visibleCode === 0) {
        return cur;
    }
    const preLevel = statusLevel[String(pre.accountStatus || 'other')];
    const curLevel = statusLevel[String(cur.accountStatus || 'other')];
    return preLevel > curLevel ? cur : pre;
};
export const getValidEmail = (_pre, _cur, isMainAccount = true) => {
    const pre = transContactModel2ContactItem(_pre);
    const cur = transContactModel2ContactItem(_cur);
    const compareArr = ['type', 'customerRole', 'createTime', 'id'];
    const compareMap = {
        type: {
            customer: 4,
            clue: 3,
            enterprise: 5,
            personal: 2,
            external: 1,
            team: -1,
            recent: -1,
        },
        customerRole: {
            manager: 3,
            colleague: 2,
            openSea: 1,
            other: 0,
            undefined: 0,
        },
        status: {
            1: 1,
            2: 1,
            3: 1,
            4: 0,
            5: 1,
        },
    };
    let result;
    compareArr.forEach(prop => {
        if (!result && pre[prop] !== cur[prop]) {
            let value = pre[prop];
            let value2 = cur[prop];
            const obj = compareMap[prop];
            if (obj) {
                if (!isMainAccount && (value === 'customer' || value === 'clue')) {
                    value = '0';
                }
                else {
                    value = obj[value + ''];
                }
                if (!isMainAccount && (value2 === 'customer' || value2 === 'clue')) {
                    value2 = '0';
                }
                else {
                    value2 = obj[value2 + ''];
                }
            }
            if (value && value2) {
                result = value.toString().localeCompare(value2.toString(), 'zh') >= 0 ? _pre : _cur;
            }
        }
    });
    return result || _pre;
};
export const filterNotDisplayEmailSearchRes = (list) => {
    const filter = [];
    list.forEach(model => {
        const { contact: { type, hitQuery }, contactInfo, } = model;
        if (type === 'enterprise' && !(hitQuery === null || hitQuery === void 0 ? void 0 : hitQuery.length)) {
            const bool = contactInfo.some(item => { var _a; return item.contactItemType === 'EMAIL' && !((_a = item.hitQuery) === null || _a === void 0 ? void 0 : _a.includes('contactItemVal')) && item.isDefault; });
            if (!bool) {
                filter.push(model);
            }
        }
        else {
            filter.push(model);
        }
    });
    return filter;
};
